export default {
    methods: {
        setErrors(data) {
            let errors = {};

            if (typeof data === 'object') {
                for (let name in data.errors) {
                    let error = data.errors[name];

                    if (typeof data === 'object') {
                        errors[name] = error[0];
                    } else {
                        errors[name] = error;
                    }
                }
            } else {
                errors.general = 'Something went wrong. Please try again.';
            }

            return errors;
        }
    }
}
